import { Pipe, PipeTransform } from '@angular/core';

import { getColor } from '../constants/constants';

@Pipe({
  name: 'getColor',
  standalone: true,
})
export class GetColorPipe implements PipeTransform {
  transform(data: any, parameter: string, greenTableDesign: boolean) {
    return getColor(data, parameter, greenTableDesign);
  }
}
